angular.module('dentalLinksServices')

.constant('NO_CACHE_HEADERS', {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
})

.factory('Auth', ['$cookies', '$location', '$rootScope', 'AUTH_EVENTS', 'USER_ROLES', 'Role', function ($cookies, $location, $rootScope, AUTH_EVENTS, USER_ROLES, Role) {
    var auth;
    return {
        authorize: function (roles) {
            if (roles === undefined) {
                return true;
            } else if(Array.isArray(roles) && typeof(roles[0]) === 'string'){
                roles = Role.getRolesByNames(roles);
            }
            auth = $cookies.getObject('auth_context') || {};

            if(auth.email){
                auth.roles = Role.getRolesByNames(auth.roles);
                return Role.hasRoles(roles, auth.roles);
            }

            return false;
        },
        get: function () {
            return $cookies.getObject('auth_context');
        },
        getOrRedirect: function () {
            var result = $cookies.getObject('auth_context');
            if (result) {
                // Ensure roles are normalized before checking admin
                var roles = Role.getRolesByNames(result.roles || []);
                result.is_admin = Role.hasRoles([USER_ROLES.admin], roles);
                return result;
            } else {
                // Centralized unauthenticated handling: broadcast event with intended URL
                var redirectUrl = $location.url();
                var params = $location.search();
                $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated, {redirect: redirectUrl, params: params});
            }
        },
        set: function (value) {
            auth = value;
            $cookies.putObject('auth_context', value, {path: '/'});
        },
        remove: function () {
            auth = {};
            $cookies.remove('auth_context', {path: '/'});
        },
        hasRole: function(role) {
            if (!auth || !auth.roles) {
                return false;
            }
            var roles = Array.isArray(role) ? role : [role];
            if (typeof(roles[0]) === 'string') {
                roles = Role.getRolesByNames(roles);
            }

            return Role.hasRoles(roles, auth.roles);
        }
    };
}])

.factory('Alert', ['$timeout', function ($timeout) {
    var push = function (alerts, type, message, disableAutoHide) {
        var alert = { type: type, message: message, promise: disableAutoHide ? undefined : $timeout(function () {
            alerts.splice(alerts.indexOf(alert), 1);
        }, 10000)};
        alerts.push(alert);
    };
    return {
        error: function (alerts, message, disableAutoHide) {
            push(alerts, 'danger', message, disableAutoHide);
        },
        warning: function (alerts, message, disableAutoHide) {
            push(alerts, 'warning', message, disableAutoHide);
        },
        info: function (alerts, message, disableAutoHide) {
            push(alerts, 'info', message, disableAutoHide);
        },
        success: function (alerts, message, disableAutoHide) {
            push(alerts, 'success', message, disableAutoHide);
        },
        close: function (alerts, index) {
            $timeout.cancel(alerts[index].promise); //cancel automatic removal
            alerts.splice(index, 1);
        }
    }
}])

.factory('Practice', ['$resource', 'API_ENDPOINT', 'NO_CACHE_HEADERS',
    function ($resource, API_ENDPOINT, NO_CACHE_HEADERS) {
        return $resource(API_ENDPOINT + '/practices/:practiceId', {}, {
            searchPractice: {method: 'GET', url: API_ENDPOINT + '/practices/search', isArray: true, headers: NO_CACHE_HEADERS, skipSpinner: true},
            publicSearchPractice: {method: 'GET', url: API_ENDPOINT + '/practices/public_search', isArray: true, headers: NO_CACHE_HEADERS, skipSpinner: true},
            getByPublicId: {method: 'GET', url: API_ENDPOINT + '/practices/public_show/:publicId', headers: NO_CACHE_HEADERS},
            // DCL-431: unauthenticated provider list for the guest flow, keyed by
            // the public_id already present in the referral link
            getPublicProviders: {method: 'GET', url: API_ENDPOINT + '/practices/public_providers/:publicId', isArray: true, headers: NO_CACHE_HEADERS},
            superUserSearchPractice: {method: 'GET', url: API_ENDPOINT + '/practices/super_user_search', isArray: true, headers: NO_CACHE_HEADERS, skipSpinner: true},
            update: {method: 'PUT'},
            deleteAndMoveReferral: {method: 'POST', url: API_ENDPOINT + '/practices/delete_and_move_referral'},
            getAllInvitees: {method: 'POST', url: API_ENDPOINT + '/practices/all_invitees', isArray: true},
            checkContainsDoctor: {method: 'POST', url: API_ENDPOINT + '/practices/:practiceId/check_contains_doctor'},
            updateStatus: {method: 'POST', url: API_ENDPOINT + '/practices/:practiceId/update_status'},
            getStats: {method: 'GET', url: API_ENDPOINT + '/practices/:practiceId/stats'},
            // DCL-605: super console, the practice's latest campaign emails
            getSentEmails: {method: 'GET', url: API_ENDPOINT + '/practices/:practiceId/sent_emails', isArray: true, headers: NO_CACHE_HEADERS},
            getSentEmail: {method: 'GET', url: API_ENDPOINT + '/practices/:practiceId/sent_emails/:emailId', headers: NO_CACHE_HEADERS},
            getOwnerParamsByConversionToken: {method: 'GET', url: API_ENDPOINT + '/practices/get_owner_params_by_conversion_token', params: {conversion_token: '@conversion_token'}},
            getGeoJson: {method: 'GET', url: API_ENDPOINT + '/practices/geo_json'}
        });
    }])


.factory('Patient', ['$resource', 'API_ENDPOINT', 'NO_CACHE_HEADERS', function ($resource, API_ENDPOINT, NO_CACHE_HEADERS) {
    return $resource(API_ENDPOINT + '/patients/:id', {}, {
        update: {method: 'PUT'},
        searchPatient: {method: 'GET', url: API_ENDPOINT + '/patients/search', isArray: true, headers: NO_CACHE_HEADERS, skipSpinner: true},
        searchPatientDuplicate: {method: 'GET', url: API_ENDPOINT + '/patients/search_duplicate'}
    });
}])

.factory('Referral', ['$resource', 'API_ENDPOINT', 'NO_CACHE_HEADERS', function ($resource, API_ENDPOINT, NO_CACHE_HEADERS) {
    return $resource(API_ENDPOINT + '/referrals/:id', {id: '@id'}, {
        update: {method: 'PUT'},
        updateStatus: {method: 'PUT', url: API_ENDPOINT + '/referrals/:id/status'},
        updateArchived: {method: 'PUT', url: API_ENDPOINT + '/referrals/:id/archived'},
        // Force fresh data for history page queries; prevent 304 responses from cached content
        findByPractice: {method: 'GET', url: API_ENDPOINT + '/referrals/practice/:id', headers: NO_CACHE_HEADERS},
        // DCL-431: scoped by the invitation's token, not its enumerable id
        countByInvited: {method: 'GET', url: API_ENDPOINT + '/referrals/count_by_invited'},
        countByPractice: {method: 'GET', url: API_ENDPOINT + '/referrals/count_by_practice/:id'},
        createGuestReferral: {method: 'POST', url: API_ENDPOINT + '/referrals/new/guest_referral'},
        sendGuestReferralUpdatedEmail: {method: 'POST', url: API_ENDPOINT + '/referrals/:id/send_guest_referral_updated_email'},
        getNoteDrafts: {method: 'GET', url: API_ENDPOINT + '/referrals/:id/note_drafts', isArray: true},
        checkReverseReferral: {method: 'GET', url: API_ENDPOINT + '/referrals/check_reverse_referral'},
        // DCL-539: persist per-user dismissal of the beyond-allowance notice
        dismissAllowanceNotice: {method: 'POST', url: API_ENDPOINT + '/referrals/:id/allowance_notice_dismissal'},
    });
}])

.factory('Login', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/sign_in', {}, {
        login: { method: 'POST', withCredentials: true},
        logout: {method: 'DELETE', url: API_ENDPOINT + '/sign_out', withCredentials: true}
    });
}])

.factory('ProviderInvitation', ['$resource', 'API_ENDPOINT', 'NO_CACHE_HEADERS', function ($resource, API_ENDPOINT, NO_CACHE_HEADERS) {
    
    return $resource(API_ENDPOINT + '/invitations/:id', {id: '@id'}, {
        query: {method: 'GET', url: API_ENDPOINT + '/invitations', isArray: true, headers: NO_CACHE_HEADERS, skipSpinner: true},
        superUserSearch: {method: 'GET', url: API_ENDPOINT + '/invitations/super_user_search', isArray: true, headers: NO_CACHE_HEADERS, skipSpinner: true},
        findByToken: {method: 'GET', url: API_ENDPOINT + '/invitations/find_by_token', headers: NO_CACHE_HEADERS},
        findByEmail: {method: 'GET',  url: API_ENDPOINT + '/invitations/find_by_email', isArray: true, headers: NO_CACHE_HEADERS, skipSpinner: true},
        practice: {method: 'GET', url: API_ENDPOINT + '/invitations/practice/:id', isArray: true},
        resend: {method: 'POST', url: API_ENDPOINT + '/invitations/resend/:id'},
        // DCL-431: id-free resend used by the pre-authentication registration form
        resendByEmail: {method: 'POST', url: API_ENDPOINT + '/invitations/resend_by_email'},
        mailUnsubscribe: {method: 'GET', url: API_ENDPOINT + '/invitations/mail_unsubscribe', params: {md_id: '@md_id'}}
    });
}])

// Centralized helper for email validation and handling of "invited" flow
//
// DCL-431: this used to fan out to users#find_by_email + invitations#find_by_email
// and resend by invitation id — all three unauthenticated, so anyone could
// enumerate accounts and spam invitation emails. It now calls the purpose-built
// Registration.emailStatus (a status enum, no ids or emails) and resends by
// email. The observable behaviour is unchanged, including the deliberate
// "resolve on error" path: a failed or throttled check must not block a
// legitimate registration, and pre_register still rejects duplicates server-side.
.factory('InvitationEmailHelper', ['$q', 'Notification', '$uibModal', 'ModalHandler', 'ProviderInvitation', 'Registration',
    function ($q, Notification, $uibModal, ModalHandler, ProviderInvitation, Registration) {
        function openResentModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/registration_email_send_message.html',
                controller: 'RegistrationEmailResendModalController'
            });
            ModalHandler.set(modalInstance);
        }

        function offerResend(scope, email) {
            scope.resendEmail = email;
            Notification.error('invitation.email.invited', {
                resend: function () {
                    ProviderInvitation.resendByEmail({ email: scope.resendEmail }, function () {
                        openResentModal();
                    }, function (failure) {
                        var message = failure && failure.data && failure.data.errors && failure.data.errors[0];
                        Notification.error(message || 'default.error');
                    });
                }
            });
        }

        return {
            // options: { scope }
            validate: function (email, options) {
                if (!email) {
                    return $q.reject();
                }

                var deferred = $q.defer();

                Registration
                    .emailStatus({ email: email })
                    .$promise
                    .then(function (result) {
                        var status = result && result.status;

                        if (status === 'registered') {
                            Notification.error('invitation.email.register');
                            deferred.reject();
                        } else if (status === 'invited') {
                            if (options && options.scope) {
                                offerResend(options.scope, email);
                            }
                            deferred.reject();
                        } else {
                            deferred.resolve();
                        }
                    }, function () {
                        // Check unavailable or throttled — treat the address as usable
                        // rather than blocking the form. Duplicates are still caught on
                        // submit (see preRegistrationController's failure handler).
                        deferred.resolve();
                    });

                return deferred.promise;
            }
        };
    }
])

.factory('Registration', ['$resource', 'API_ENDPOINT', 'NO_CACHE_HEADERS', function ($resource, API_ENDPOINT, NO_CACHE_HEADERS) {
    return $resource(API_ENDPOINT + '/sign_up', {}, {
        create_no_login_user: {method: 'POST', url: API_ENDPOINT + '/register_no_login_user'},
        register_pending_review: {method: 'POST', url: API_ENDPOINT + '/register_pending_review'},
        requestEmailChange: {method: 'POST', url: API_ENDPOINT + '/request_email_update'},
        confirmEmail: {method: 'POST', url: API_ENDPOINT + '/confirm_email'},
        convertGuest: {method: 'POST', url: API_ENDPOINT + '/convert_guest'},
        sendConvertGuestEmail: {method: 'POST', url: API_ENDPOINT + '/send_convert_guest_email'},
        preRegister: {method: 'POST', url: API_ENDPOINT + '/pre_register'},
        // DCL-431: status-only pre-auth email check; returns
        // {status: 'available'|'registered'|'invited'}
        emailStatus: {method: 'GET', url: API_ENDPOINT + '/registrations/email_status', headers: NO_CACHE_HEADERS, skipSpinner: true}
    })
}])

// devise_for provides route to PasswordsController for this endpoint
.factory('Password', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/password', {}, {
        // sends email with the link to form
        // body: {user: {email: 'asdf@asdf.com'}}
        reset: {method: 'POST'},
        // finds user by token and saves provided password for that user
        // body: {user: {password: 'xyz', password_confirmation: 'xyz', reset_password_token: 'asdf', format: 'json'}}
        change: {method: 'PUT'},
    })
}])

.factory('S3Bucket', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/s3', {}, {
        getCredentials: {method: 'GET'}
    });
}])

.factory('Note', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/notes/:id', {}, {
        update: {method: 'PUT'}
    });
}])

.factory('Attachment', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/attachments/:id', {}, {
        update: { method: 'PUT'}
    });
}])

.factory('Procedure', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/procedures', {}, {
        practiceTypes: {method: 'GET', url: API_ENDPOINT + '/practice_types', params: {'include_procedures': true}, isArray: true}
    })
}])

.factory('Address', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/addresses/:id', {}, {
        search: {method: 'GET', url: API_ENDPOINT + '/addresses/search', isArray: true},
        update: {method: 'PUT' }
    });
}])

.factory('User', ['$resource', 'API_ENDPOINT', 'NO_CACHE_HEADERS', function ($resource, API_ENDPOINT, NO_CACHE_HEADERS) {
    return $resource(API_ENDPOINT + '/users/:id', {}, {
        // also supports filtering by user type via `user_type` param: 'regular' (default), 'guest', or 'all'
        findByEmail: {method: 'GET', url: API_ENDPOINT + '/users/find_by_email', isArray: true, headers: NO_CACHE_HEADERS},

        getInvitees: {method: 'GET', url: API_ENDPOINT + '/invitees/:user_id', isArray: true},
        getAllUsers: {method: 'GET', url: API_ENDPOINT + '/all_users', isArray: true},
        getOtherProviders: {method: 'GET', url: API_ENDPOINT + '/other_providers', isArray: true},
        getProviders: {method: 'GET', url: API_ENDPOINT + '/providers', isArray: true},
        addressIds: {method: 'GET', url: API_ENDPOINT + '/users/:id/address_ids', isArray: true},
        updateAddressIds: {method: 'PUT', url: API_ENDPOINT + '/users/:id/address_ids'},
        updateName: {method: 'PUT', url: API_ENDPOINT + '/users/:id/name'},
        updateIsAdmin: {method: 'PUT', url: API_ENDPOINT + '/users/:id/is_admin'},
        updateSpecialty: {method: 'PUT', url: API_ENDPOINT + '/users/:id/specialty'},
        updateNotificationPreference: {method: 'PUT', url: API_ENDPOINT + '/users/:id/notification_preference'},
        changePassword: {method: 'PUT', url: API_ENDPOINT + '/users/:id/change_password'},
        sendPasswordInvitation: {method: 'PUT', url: API_ENDPOINT + '/users/:id/password'},
        savePassword: {method: 'POST', url: API_ENDPOINT + '/save_password'},
        createGuest: {method: 'POST', url: API_ENDPOINT + '/guest'},
        activateGuestReferral: {method: 'GET', params: {activation_token: '@activation_token'}, url: API_ENDPOINT + '/activate_guest_referral'},
        mailUnsubscribe: {method: 'GET', params: {md_id: '@md_id', confirm: '@confirm'}, url: API_ENDPOINT + '/user/mail_unsubscribe'}
    })
}])

.factory('File', [function () {
    return {
        isImage: function (filename) {
            return filename.toLowerCase().search(/\.(jpg|jpeg|png|gif|bmp)$/) >= 0;
        }
    }
}])

.factory('Spinner', [function () {
    /*
     This spinner implementation supports several asynchronous requests at the same time.
     It shows spinner until all requests are resolved. Every call to show() will add request to a pseudo-queue and will remove it from queue after hide() is called.
     Loading indicator is shown only when loading().numLoads > 0 (indicator is shown until last request is finished)
     */
    var loading = {numLoads: 0}; //need angular object to pass and return by reference
    return {
        show: function () {
            loading.numLoads++;
        },
        hide: function () {
            loading.numLoads--;
        },
        loading: function () {
            return loading;
        }
    }
}])

// TODO: refactor.
// It's only needed for when going back in browser history - dialog stays open without it.
.factory('ModalHandler', [function () {
    var modalInstance;
    return {
        dismissIfOpen: function () {
            if (modalInstance && modalInstance.dismiss) {
                modalInstance.dismiss('cancel');
            }
        },
        set: function (modal) {
            modalInstance = modal;
        },
        dismiss: function(modal){
            modal.dismiss('cancel');
        },
        close: function(modal, result){
            modal.close(result);
        }
    }
}])

.factory('Designation', ['$resource', 'API_ENDPOINT', function($resource, API_ENDPOINT){
    return $resource(API_ENDPOINT + '/designations/:id', {}, {
        getAll: {method: 'GET', isArray: true},
        update: {method: 'PUT'}
    });
}])

.factory('PracticeEditMode', [function(){
    var editBtn = {};
    var saveBtn = {};
    var addAddressBtn = {};
    var editFormCtrl = {};
    var formCtrl = {};
    var onEditCallback = null;
    var onSaveCallback = null;
    return {
        init: function(editFormControl, formControl, editButton, addAddressButton, saveButton){
            editBtn = editButton;
            saveBtn = saveButton;
            addAddressBtn = addAddressButton;
            editFormCtrl = editFormControl;
            formCtrl = formControl;
        },
        on: function(){
            editBtn.addClass('hide');
            saveBtn.removeClass('hide');
            addAddressBtn.removeClass('hide');
            editFormCtrl.enableControls();
            if (onEditCallback) {
                onEditCallback();
            }
        },
        off: function(){
            if (formCtrl.$valid) {
                editBtn.removeClass('hide');
                saveBtn.addClass('hide');
                addAddressBtn.addClass('hide');
                editFormCtrl.disableControls();
                if (onSaveCallback) {
                    onSaveCallback();
                }
            }
        },
        setOnEditCallback: function(callback) {
            onEditCallback = callback;
        },
        setOnSaveCallback: function(callback) {
            onSaveCallback = callback;
        }
    }
}])

.factory('Notification', ['$timeout', function ($timeout) {
    var notification = {message: undefined, type: undefined, promise: undefined, params: undefined};

    // Helper to cancel existing timeout if a new message comes in or we close it
    var cancelPromise = function() {
        if (notification.promise) {
            $timeout.cancel(notification.promise);
            notification.promise = undefined;
        }
    };

    return {
        info: function(message, params) {
            cancelPromise();
            if (Array.isArray(message)) {
                message = message[0];
            }
            notification.message = message;
            notification.type = 'info';
            notification.params = params;
        },
        success: function(message, params) {
            cancelPromise();
            if (Array.isArray(message)) {
                message = message[0];
            }
            notification.message = message;
            notification.type = 'success';
            notification.params = params;

            // Auto-dismiss success messages after 8 seconds
            notification.promise = $timeout(function() {
                notification.message = undefined;
            }, 8000);
        },
        warning: function(message, params) {
            cancelPromise();
            if (Array.isArray(message)) {
                message = message[0];
            }
            notification.message = message;
            notification.type = 'warning';
            notification.params = params;
        },
        error: function(message, params) {
            cancelPromise();
            if (Array.isArray(message)) {
                message = message[0];
            }
            notification.message = message;
            notification.type = 'danger';
            notification.params = params;

            // DCL-412: auto-dismiss error/validation toasts after 10 seconds so a
            // stale message (e.g. a CBCT validation error) can't linger and
            // contradict a since-corrected selection. dontHideOnRequest only
            // protects against the request interceptor's Notification.close();
            // it does not opt out of this timer.
            notification.promise = $timeout(function() {
                notification.message = undefined;
            }, 10000);
        },
        get: function() {
            return notification;
        },
        close: function() {
            cancelPromise();
            if (!(notification.params && notification.params.dontHideOnRequest)) {//need this for a case when user creates referral with non-acceptable attachment - we need to create referral succesfully, but show notification that attachment was rejected.
                notification.message = undefined;
            }
        },
        // DCL-412: explicit user dismissal (the toast's × button). Unlike close()
        // this always clears the message, even when dontHideOnRequest is set —
        // that flag only exists to survive the request interceptor's automatic
        // close(), not to make a toast un-dismissable by the user.
        dismiss: function() {
            cancelPromise();
            notification.message = undefined;
        }
    }
}])

// DCL-649: the email verifier's rejection of an address, as a toast — with the
// corrected address (Emailable's did_you_mean) when the 422 carries a
// `suggestion`. DCL-662: every endpoint that verifies an address (pre_register,
// guest signup, invitations) marks the rejection with
// {error: 'bad.email.address'}, so isRejection recognises it for every caller.
// It also accepts the legacy keys (pre_register `errors`, guest `message`), so
// this SPA still recognises a backend from before DCL-662 during a rolling
// deploy or a backend rollback; drop them with the backend's legacy keys.
.factory('BadEmailNotice', ['Notification', function (Notification) {
    var BAD_EMAIL = 'bad.email.address';
    return {
        isRejection: function (data) {
            return !!data && (data.error === BAD_EMAIL || data.errors === BAD_EMAIL ||
                              data.message === BAD_EMAIL);
        },
        notify: function (data) {
            if (data && data.suggestion) {
                Notification.error('bad.email.address.suggestion', {suggestion: data.suggestion});
            } else {
                Notification.error('bad.email.address');
            }
        }
    };
}])

.factory('ProgressIndicator', function(){
    var progress = {show: false, value: 0};
    return {
        start: function(){
            progress.show = true;
        },
        set: function(value){
            progress.value = value;
        },
        finish: function(){
            progress.value = 0;
            progress.show = false;
        },
        get: function(){
            return progress;
        }
    }
})

.factory('Report', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/report', {time_type: '@time_type'}, {
        getInvitations: {method: 'GET', url: API_ENDPOINT + '/report/show_invitations?time_type=:time_type', isArray: true},
        getPractices: {method: 'GET', url: API_ENDPOINT + '/report/show_practices?time_type=:time_type', isArray: true},
        getUsers: {method: 'GET', url: API_ENDPOINT + '/report/show_users?time_type=:time_type', isArray: true},
        getPendingPractices: {method: 'GET', url: API_ENDPOINT + '/report/show_pending_practices', isArray: true},
        // Metric history endpoints
        getMetrics: {method: 'GET', url: API_ENDPOINT + '/report/metrics'},
        getMetricsHistory: {method: 'GET', url: API_ENDPOINT + '/report/metrics_history'},
        getMetricsDrilldown: {method: 'GET', url: API_ENDPOINT + '/report/metrics_drilldown'},
        getMetricsCompare: {method: 'GET', url: API_ENDPOINT + '/report/metrics_compare'},
        captureMetrics: {method: 'POST', url: API_ENDPOINT + '/report/capture_metrics'},
        // Geocoding report endpoint
        getGeocoding: {method: 'GET', url: API_ENDPOINT + '/report/geocoding'},
        // Heavy receivers outreach report (DCL-540)
        getHeavyReceivers: {method: 'GET', url: API_ENDPOINT + '/report/heavy_receivers'},
        // Branding requests report
        getBrandingRequests: {method: 'GET', url: API_ENDPOINT + '/report/branding_requests'},
        updateBrandingRequest: {method: 'PATCH', url: API_ENDPOINT + '/report/branding_requests/:id', params: {id: '@id'}}
    });
}])

.factory('RejectedEmailAddresses', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/rejected_email_addresses', {}, {
        get: { method: 'GET' } // returns { rejections: [...], total_count: N }
    });
}])

.factory('EmailBlacklist', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/email_blacklist/:id', { id: '@id' }, {
        get: { method: 'GET' }, // returns { entries: [...], total_count: N }
        create: { method: 'POST' },
        remove: { method: 'DELETE' }
    });
}])

.factory('UserEmailSuppression', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    // DCL-462: provider email-suppression status + removal for a user
    return $resource(API_ENDPOINT + '/users/:id/email_suppression', {id: '@id'}, {
        get: {method: 'GET'},
        remove: {method: 'DELETE'}
    });
}])

.factory('Activity', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/activities/:id', {id: '@id'}, {
        find: {method: 'GET', url: API_ENDPOINT + '/activities', isArray: false},
        patientsChanges: {method: 'GET', url: API_ENDPOINT + '/activities/patient', isArray: false}
    });
}])

.factory('Support', ['$resource', 'API_ENDPOINT', function($resource, API_ENDPOINT){
        return $resource(API_ENDPOINT + '/support', {}, {
            sendQuestion: {method: 'POST', url: API_ENDPOINT + '/support/send_question'}
        })
}])
.factory('CustomBranding', ['$css', '$cookies', function($css, $cookies){
    var currentBranding = {};
    // Cache-busting timestamp from build
    var buildTimestamp = window.env && window.env.datetime ? window.env.datetime : Date.now();
    
    function addCssWithCacheBust(path) {
        $css.add(path + '?_=' + encodeURIComponent(buildTimestamp));
    }
    
    return {
        apply: function(brandingSettings){
            if (brandingSettings.pidBased || !currentBranding.pidBased){
                //apply branding if from pid or if current branding is not from pid (don't allow to override pid-based branding by non-pid-based branding)
                this.save(brandingSettings);
                currentBranding = brandingSettings;
                var parsedSetting = JSON.parse(brandingSettings.settings);
                $css.removeAll();
                addCssWithCacheBust('brandings/' + parsedSetting.path);
            } else {
                $css.removeAll();
                addCssWithCacheBust('brandings/branding-default.css');
            }
        },
        // A practice's branding hangs off its designation, so the branding a
        // session shows belongs to whoever the session belongs to. Every flow
        // that establishes an identity goes through here: login, and both
        // directions of impersonation (DCL-286). Clearing first is what keeps
        // the previous identity's stylesheet and cookie from surviving the
        // switch — the impersonation flows are $state reloads, not page
        // reloads, so nothing else re-reads the cookie.
        applyForUser: function(user){
            this.remove();
            var practice = (user || {}).practice;
            var branding = practice && practice.designation && practice.designation.branding;
            if (branding) {
                this.apply({pidBased: false, settings: branding.ui_data});
            }
        },
        save: function(value) {
            $cookies.putObject('branding', value, {path: '/'});
        },
        get: function() {
            return $cookies.getObject('branding');
        },
        remove: function() {
            $css.removeAll();
            addCssWithCacheBust('brandings/branding-default.css');
            $cookies.remove('branding', {path: '/'});
            currentBranding = {};
        }
    }
}])
.factory('BrandingSettings', ['$resource', 'API_ENDPOINT', function($resource, API_ENDPOINT){
    return $resource(API_ENDPOINT + '/branding', {}, {});
}])

.factory('BrandingRequest', ['$resource', 'API_ENDPOINT', function($resource, API_ENDPOINT){
    return $resource(API_ENDPOINT + '/branding_requests/:id', { id: '@id' }, {
        pending: { method: 'GET', isArray: false },
        remove: { method: 'DELETE' }
    });
}])
.factory('FeatureConfig', ['$resource', 'API_ENDPOINT', function($resource, API_ENDPOINT){
    return $resource(API_ENDPOINT + '/feature_configs', {}, {
        findByName: {method: 'GET'}
    });
}])
.factory('Role', ['USER_ROLES', function(USER_ROLES){
    var ROLES = [];

    for(var prop in USER_ROLES){
        if(USER_ROLES.hasOwnProperty(prop)){
           ROLES.push(USER_ROLES[prop]);
        }
    }

    return {
        getFromMask: function(rolesMask){
            return ROLES.filter(function(role){
                return (rolesMask & role.mask) != 0;
            });
        },
        convertRolesToMask: function(inputArray){
            var mask = 0;

            inputArray
                .map(function(elem){
                    if(typeof(elem) === 'object') {
                        mask = mask | elem.mask;
                    } else if(typeof(elem) === 'string'){
                        var role = {};
                        for(var i = 0; i < ROLES.length; i++){
                            if(ROLES[i].id === elem){
                                role = ROLES[i];
                            }
                        }
                        mask = mask | role.mask;
                    }
                });

            return mask;
        },
        getAllRoles: function(){
            return ROLES.filter(function(role){
                return role.id !== 'super' && role.id !== 'public';
            });
        },
        getRolesByNames: function(names){
            var outputRoles = [];
            names.forEach(function(name){
                for(var i = 0; i < ROLES.length; i++){
                    if(ROLES[i].id === name){
                        outputRoles.push(ROLES[i]);
                    }
                }
            });
            return outputRoles;
        },
        hasRoles: function(requiredRoles, userRoles){
            var hasRole = false;

            requiredRoles.forEach(function(requiredRole){
                userRoles.forEach(function(userRole){
                    if(requiredRole.mask === userRole.mask){
                        hasRole = true;
                    }
                });
            });

            return hasRole;
        }
    };

}])
.factory('PatientPortal', ['$resource', 'API_ENDPOINT', function ($resource, API_ENDPOINT) {
    return $resource(API_ENDPOINT + '/patient_portal', {}, {
        ssoToken: { method: 'POST', url: API_ENDPOINT + '/patient_portal/sso_token' }
    });
}])

.factory("referralColorClasses", [function() {
    return function(status) {
        return {
            'label-info':    status == 'new',
            'label-primary': status == 'scheduled',
            'label-warning': status == 'active',
            'label-success': status == 'completed',
            'label-default': status == 'draft' || status == 'archived' || status == 'expired'
        };
    };
}]);
